import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, useSlots } from 'vue';
import { BFormInput, BTable } from 'bootstrap-vue';
import { TableField, FieldType, Pagination, SortConfig } from '@/typings/dynamicTable';
import CButton from './CButton/CButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicTable',
  props: {
    tableConfig: null,
    items: null,
    paginationData: { default: () => ({
            currentPage: 1,
            pageSize: 10,
            totalItemCount: 0
        }) },
    loading: { type: Boolean },
    customSearchAndPagination: { type: Boolean },
    onRowClicked: null,
    tBodyTrClass: null,
    sort: null
  },
  emits: ["search", "page-change", "change-sort-mode", "sort-items"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'search', value: string): void;
    (event: 'page-change', page: number): void;
    (event: 'change-sort-mode', e: MouseEvent): void;
    (event: 'sort-items', setMode?: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tableConfig: TableField<any>[], items?: unknown[], paginationData: Pagination, loading?: boolean, customSearchAndPagination?: boolean, onRowClicked?: (row: unknown) => void, tBodyTrClass?: string, sort?: SortConfig };





const slots = useSlots();

const lastKeySorted = ref<string | null>(null);

const isClickActive = computed(() => {
    return !!props.onRowClicked;
});

const getSlotName = computed(() => {
    return (field: TableField) => `cell(${field.key})`;
});

const getHeaderSlotName = computed(() => {
    return (field: TableField) => `head(${field.key})`;
});

const executeAction = (field: TableField, item: Record<string, unknown>, event: MouseEvent) => {
    if (!field.action) return;
    event.stopPropagation();
    field.action(item);
};

const rowClicked = (item: unknown) => {
    props.onRowClicked?.(item);
};

const getRowsClasses = () => {
    const classes = ['custom-body'];
    if (isClickActive) classes.push('cursor-pointer');
    if (props.tBodyTrClass) classes.push(props.tBodyTrClass);
    return classes.join(' ');
};

const onColumnHeaderClick = (column: TableField) => {
    if (column.type !== FieldType.Sort || !column.sortKey) return;
    if (lastKeySorted.value !== column.sortKey) {
        emit('sort-items', column.sortKey);
        lastKeySorted.value = column.sortKey;
    } else {
        emit('change-sort-mode', new MouseEvent('click'));
    }
};

return { __sfc: true,props, emit, slots, lastKeySorted, isClickActive, getSlotName, getHeaderSlotName, executeAction, rowClicked, getRowsClasses, onColumnHeaderClick, BFormInput, BTable, FieldType, CButton }
}

})